import { CallToAction } from "../CTA/CallToActionButton";

export const BannerInfoCardVariant = ({
  imageUrl,
  imageAlt,
  headerText,
  subtitle,
  content,
  isEven,
  ctas,
  formattedSectionStyles,
  footer,
}) => {

  const imageBorderRadius = isEven
    ? " md:rounded-tr-[50px] md:rounded-br-[50px]"
    : "md:rounded-tl-[50px] md:rounded-bl-[50px]";
  return (
    <article
      className={`flex flex-col gap-2 sm:gap-4  ${formattedSectionStyles?.cardStyling?.backgroundColor || formattedSectionStyles?.inverseColor} ${
        isEven ? "sm:flex-row-reverse" : "sm:flex-row"
      } rounded-[50px] max-w-[1200px] justify-between`}
    >
      <div
        className={`relative md:block md:basis-7/12 `}
      >
        <img
          src={imageUrl}
          alt={imageAlt}
          className={`object-cover w-full h-full block rounded-t-[50px] md:rounded-t-[0px] ${imageBorderRadius} `}
          style={{
            aspectRatio: "3 / 2",
          }}
          loading="lazy"
        />
      </div>

      <div className="md:basis-5/12  flex flex-col justify-start text-center md:p-12">
        {subtitle && (
          <span className={`text-is2_md ${formattedSectionStyles.headerStyling}`}>
            {subtitle}
          </span>
        )}
        {headerText && (
          <h1 className={`${formattedSectionStyles.headerStyling} mt-2 mb-9 mx-10 md:mx2`}>
            {headerText}
          </h1>
        )}
        <div className="[&_p]:text-is2-gray-150 [&_a]:text-is2-blue [&_a]:no-underline px-4">
          {content}
        </div>
        {footer && (
          <div className="text-is2-gray-150 text-sm mt-4">{footer}</div>
        )}
        <div className="flex flex-col gap-4 px-8 pb-8 ">
          {ctas &&
            ctas.map((cta, index) => (
              <CallToAction
                key={`${cta.title}-${index}`}
                title={cta.buttonText || cta.title}
                {...cta}
              />
            ))}
        </div>
      </div>
    </article>
  );
};
